import fetch from "auth/FetchInterceptor";

const TrainingsService = {};

const trainingsPrefix = "/formation";

TrainingsService.getTrainings = async ({ page = 1, limit = 20 } = {}) =>
  await fetch(
    `${trainingsPrefix}/getAllFormationsForAdminSchool?page=${page}&limit=${limit}`,
    {
      method: "GET",
    }
  );
TrainingsService.getTrainingsKids = async ({ page = 1, limit = 20 } = {}) =>
  await fetch(`${trainingsPrefix}/getAllForKids?page=${page}&limit=${limit}`, {
    method: "GET",
  });

TrainingsService.getTraining = async (id) =>
  await fetch(`${trainingsPrefix}/getOneFormationForAdminSchool/${id}`, {
    method: "GET",
  });

// Langues distinctes déjà utilisées (défauts fr/en/ar inclus) pour les suggestions du formulaire
TrainingsService.getLanguages = async () =>
  await fetch(`${trainingsPrefix}/languages`, {
    method: "GET",
  });

TrainingsService.createTraining = async (data) =>
  await fetch(`${trainingsPrefix}/create`, {
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

TrainingsService.updateTraining = async (id, data) =>
  await fetch(`${trainingsPrefix}/update/${id}`, {
    method: "PUT",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

TrainingsService.deleteTraining = async (id) =>
  await fetch(`${trainingsPrefix}/deleteById/${id}`, {
    method: "DELETE",
  });

TrainingsService.addStudentToTraining = async (trainingId, students) => {
  return fetch(`${trainingsPrefix}/${trainingId}/addStudents`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: { students },
  });
};

TrainingsService.deleteStudentFromTraining = async (trainingId, studentId) =>
  await fetch(`${trainingsPrefix}/${trainingId}/deleteStudent`, {
    method: "DELETE",
    data: {
      studentFormationId: studentId,
    },
  });

TrainingsService.getTrainingStudents = async (id) =>
  await fetch(`${trainingsPrefix}/${id}/getAllStudents`, {
    method: "GET",
  });

// Récupérer les entités studentFormation d'une formation précise
TrainingsService.getStudentFormationsForFormation = async (
  trainingId,
  groupId
) =>
  await fetch(`${trainingsPrefix}/${trainingId}/studentFormations`, {
    method: "GET",
    params: { groupId },
  });

TrainingsService.approveInstructor = async (trainingId, instructorId) =>
  await fetch(
    `${trainingsPrefix}/${trainingId}/approve?instructorId=${instructorId}`,
    {
      method: "PATCH",
    }
  );

// Rejeter une demande d'enseignant pour une formation
TrainingsService.rejectInstructor = async (trainingId, instructorId, reason) =>
  await fetch(
    `${trainingsPrefix}/${trainingId}/reject?instructorId=${instructorId}`,
    {
      method: "PATCH",
      data: { reason },
    }
  );

TrainingsService.assignInstructorToTraining = async (trainingId, instructorId) =>
  await fetch(`${trainingsPrefix}/${trainingId}/assign-instructor`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: { instructorId },
  });

TrainingsService.getStudentsForTraining = async (trainingId) =>
  await fetch(`/formation/students/${trainingId}`, {
    method: "GET",
  });

TrainingsService.removeDiscount = async (studentFormationId) =>
  await fetch(`/formation/student/${studentFormationId}/remove-discount`, {
    method: "PATCH",
});

export default TrainingsService;
